<template>
  <div>
    <div class="weui-search-bar" id="searchBar" style="padding: 0;background-color:#ededed;" v-if="displayInBrowser">
      <form class="weui-search-bar__form" @submit="() => {return false;}" style="padding: 0 10px;">
        <div class="weui-search-bar__box" style="background-color: #F7F8FA;">
          <i class="weui-icon-search"></i>
          <input type="search" class="weui-search-bar__input" style="color: black;"
                 placeholder="搜索" required="" v-model="keyword"
                 @keyup="handleChange">
          <a @click="clearKeyword" style="width: 40px;">取消</a>
        </div>
      </form>
    </div>

    <div class="bar" style="position:relative;" v-else>
      <div class="searchbar" style="background-color: #F7F8FA;height: 45px;">
        <a class="searchbar-cancel close-popup" @click="clearKeyword">取消</a>
        <div class="search-input">
          <label class="icon icon-search" for="searchGoods"></label>
          <input type="search" placeholder='搜索' v-model.trim="keyword" @keyup="handleChange"/>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import EMKT from '../constant.js'

export default {
  name: 'GcSearchInput',
  data () {
    return {
      emkt: EMKT,
      keyword: ''
    }
  },
  props: {
    displayInBrowser: Boolean
  },
  emits: ['updateSearchKeyword'],
  methods: {
    handleChange () {
      this.$emit('updateSearchKeyword', this.keyword)
    },
    clearKeyword () {
      this.keyword = ''
      this.handleChange()
    }

  },
  mounted () {
    this.$weui.searchBar('#searchBar')
  }
}
</script>





// WEBPACK FOOTER //
// GcSearchInput.vue?35eea2de